{
	"name": "nadle",
	"version": "0.3.5",
	"description": "A modern, type-safe task runner for Node.js inspired by the awesome Gradle build tool",
	"type": "module",
	"scripts": {
		"build": "pnpm \"/build:/\"",
		"build:tsup": "tsup",
		"build:ts": "tsc -p tsconfig.build.json",
		"start": "pnpm run build:ts --watch --noEmit false",
		"test": "vitest"
	},
	"files": [
		"lib",
		"nadle.mjs",
		"CHANGELOG.md"
	],
	"main": "lib/index.js",
	"bin": "nadle.mjs",
	"types": "lib/index.d.ts",
	"dependencies": {
		"consola": "^3.4.2",
		"execa": "^9.6.0",
		"fastest-levenshtein": "^1.0.16",
		"find-up": "^7.0.0",
		"glob": "^11.0.2",
		"jiti": "^2.4.2",
		"lodash-es": "^4.17.21",
		"rimraf": "^6.0.1",
		"std-env": "^3.9.0",
		"tinypool": "^1.1.0",
		"tinyrainbow": "^2.0.0",
		"yargs": "^18.0.0"
	},
	"devDependencies": {
		"@size-limit/file": "^11.2.0",
		"@types/lodash-es": "^4.17.12",
		"@types/node": "^20.17.57",
		"@types/yargs": "^17.0.33",
		"fixturify": "^3.0.0",
		"knip": "^5.60.2",
		"size-limit": "^11.2.0",
		"strip-ansi": "^7.1.0",
		"tsup": "^8.5.0",
		"typescript": "^5.8.2",
		"vitest": "3.2.2"
	},
	"engines": {
		"node": ">=20"
	},
	"author": {
		"name": "Nam Hoang Le",
		"email": "namhoangle.dev@gmail.com"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/nam-hle/nadle.git",
		"directory": "packages/nadle"
	},
	"keywords": [
		"nodejs",
		"task-runner",
		"build-tool",
		"typescript",
		"cli",
		"automation",
		"gradle-inspired",
		"task-orchestration",
		"type-safe",
		"developer-tools",
		"lightweight"
	],
	"homepage": "https://nadle.dev",
	"bugs": "https://github.com/nam-hle/nadle/issues",
	"size-limit": [
		{
			"path": "lib/**",
			"limit": "40 KB",
			"name": "bundled"
		}
	]
}
